<template>
  <div>
    <AutoGrowTextEditor
      class="mt-2"
      v-model="offerLp"
      :outlined="editMode"
      @input="doChange(false)"
      @blur="doBlur"
      label="Название ЛП"
      persistent-hint
      rows="2"
      dense
    ></AutoGrowTextEditor>
    <AutoGrowTextEditor
      class="mt-2"
      v-model="dosageMedicine"
      :outlined="editMode"
      @input="doChange(false)"
      @blur="doBlur"
      label="Режим дозирования, например, 100 мг 2 раза в сутки"
      persistent-hint
      dense
      rows="2"
    ></AutoGrowTextEditor>

    <AutoGrowTextEditor
      v-model="durationTherapy"
      :outlined="editMode"
      @input="doChange(false)"
      @blur="doBlur"
      label="Продолжительность терапии в год:"
      persistent-hint
      dense
      rows="2"
    ></AutoGrowTextEditor>
    <AutoGrowTextEditor
      v-model="costOneMg"
      :outlined="editMode"
      @input="doChange(false)"
      @blur="doBlur"
      :label="`Стоимость 1 ед. ЕСКЛП ${mainName}`"
      persistent-hint
      dense
      rows="2"
    ></AutoGrowTextEditor>

    <AutoGrowTextEditor
      class="mt-2"
      v-model="esclp"
      :outlined="editMode"
      @input="doChange(false)"
      @blur="doBlur"
      label="Единицы ЕСКЛП"
      persistent-hint
      dense
      rows="2"
    ></AutoGrowTextEditor>

    <div
      v-for="(cost, idx) in costOnePatient"
      :key="cost.id"
      class="d-flex flex-wrap"
    >
      <AutoGrowTextEditor
        v-model="cost.formula"
        :outlined="editMode"
        @input="doChange(false)"
        @blur="doBlur"
        persistent-hint
        :label="`Расчет стоимости 1 года терапии одного пациента (${idx + 1}-й
          год)`"
        hint="формула расчетов с результатами"
        class="mb-3"
        dense
        rows="2"
      >
      </AutoGrowTextEditor>
      <div
        class="ml-2"
        v-if="
          editMode &&
          idx === costOnePatient.length - 1 &&
          costOnePatient.length > 1
        "
      >
        <btn-with-confirm
          v-if="editMode"
          text
          icon
          icon-main="mdi-delete-forever-outline"
          title="Удалить"
          @click="deleteCalculation"
        />
      </div>
      <v-btn
        v-if="editMode && idx === costOnePatient.length - 1"
        class="ml-2"
        @click="addPatient"
        title="Добавить расчёт стоймости"
        icon
        ><v-icon>mdi-plus</v-icon></v-btn
      >
    </div>
  </div>
</template>

<script>
import { copyObject } from '@/lib/objects'
import btnWithConfirm from '@/components/buttons/btnWithConfirm'
import AutoGrowTextEditor from '@/components/editors/AutoGrowTextEditor'

export default {
  name: 'CostManual',
  components: { btnWithConfirm, AutoGrowTextEditor },
  data: () => ({
    calculationCost: null,
    dosageMedicine: '',
    durationTherapy: '',
    costOneMg: '',
    esclp: '',
    costOnePatient: [],
    offerLp: '',
  }),
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    itemIndex: {
      type: Number,
      default: 0,
    },
    mainName: {
      type: String,
      default: '',
    },
  },
  created() {
    this.init()
  },
  watch: {
    item: 'init',
  },
  methods: {
    init() {
      this.calculationCost = copyObject(this.item) || {}
      this.dosageMedicine = this.calculationCost?.dosageMedicine || ''
      this.durationTherapy = this.calculationCost?.durationTherapy || ''
      this.esclp = this.calculationCost?.esclp || ''
      this.costOneMg = this.calculationCost?.costOneMg || ''
      this.costOnePatient = this.calculationCost?.costOnePatient || []
      this.offerLp = this.calculationCost?.offerLp || ''
    },
    doChange(force) {
      const {
        dosageMedicine,
        durationTherapy,
        esclp,
        costOneMg,
        costOnePatient,
        offerLp,
      } = this
      this.$emit(
        'change',
        {
          dosageMedicine,
          durationTherapy,
          costOneMg,
          costOnePatient,
          offerLp,
          esclp,
        },
        force
      )
    },
    doBlur() {
      this.$emit('blur')
    },
    deleteManual() {
      this.$emit('delete')
    },
    addPatient() {
      this.costOnePatient.push({ formula: '' })
      this.doChange(true)
    },
    deleteCalculation() {
      this.costOnePatient.pop()
      this.doChange(true)
    },
  },
}
</script>
